export default "__VITE_ASSET__C8qhTwWL__"